export enum ResponsibleGamingTypeEnum {
  COOL_OFF = 'coolOff',
  SELF_EXCLUSION = 'selfExclusion',
  LIMITS = 'limits',
}
